module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_2-c84b03a3d5e1b6324ef984979c578502.jpeg";